export default {
	CONNECTED: 'socket.connection.connected',
	DISCONNECTED: 'socket.connection.disconnected',
	ERROR: 'socket.connection.error',
	NOTIFICATION: 'socket.hub.notification',
	ADMINNOTIFICATION: 'socket.hub.adminnotification',
	DELAYEDPUBLICATION: 'socket.hub.delayedpublication',
	LOG: 'socket.hub.log',
	RECONNECTING: 'socket.connection.reconnecting'
};
